import { type LucideIcon } from 'lucide-react';
import { ICONOS_CATEGORIA, ICONOS_MACRO } from '@/config/iconografia';
import type { UserGoal } from '@/services';

interface GoalSelectorProps {
  value: UserGoal;
  onChange: (goal: UserGoal) => void;
}

const OPTIONS: { id: UserGoal; label: string; Icon: LucideIcon }[] = [
  { id: 'lose',     label: 'Perder',  Icon: ICONOS_MACRO.calorias },
  { id: 'maintain', label: 'Mantener', Icon: ICONOS_CATEGORIA.objetivos },
  { id: 'gain',     label: 'Aumentar', Icon: ICONOS_MACRO.proteinas },
];

const HELP: Record<UserGoal, string> = {
  lose:     'Ajustaremos tus objetivos y la estimación de calorías a un déficit.',
  maintain: 'Estimaciones equilibradas para mantener tu peso.',
  gain:     'Ajustaremos tus objetivos y la estimación de calorías a un superávit.',
};

/** Selector segmentado del objetivo del usuario (perder / mantener / aumentar). */
export function GoalSelector({ value, onChange }: GoalSelectorProps) {
  return (
    <div>
      <div
        role="radiogroup"
        aria-label="Objetivo"
        style={{
          display: 'flex',
          gap: 6,
          background: 'var(--ink-100)',
          padding: 4,
          borderRadius: 12,
        }}
      >
        {OPTIONS.map(opt => {
          const active = value === opt.id;
          return (
            <button
              key={opt.id}
              type="button"
              role="radio"
              aria-checked={active}
              onClick={() => onChange(opt.id)}
              style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 4,
                padding: '10px 6px',
                borderRadius: 9,
                border: 'none',
                cursor: 'pointer',
                background: active ? 'var(--green-grad)' : 'transparent',
                color: active ? '#fff' : 'var(--ink-500)',
                fontWeight: active ? 700 : 500,
                fontSize: 12,
                transition: 'all .2s',
              }}
            >
              <opt.Icon size={20} color={active ? '#fff' : 'var(--ink-400)'} aria-hidden="true" />
              {opt.label}
            </button>
          );
        })}
      </div>
      <div style={{ fontSize: 12, color: 'var(--ink-500)', marginTop: 8, lineHeight: 1.4 }}>
        {HELP[value]}
      </div>
    </div>
  );
}
